const PageTemplateType = require('constants/PageTemplateType');

const SpaTemplatesInfo = [{
    template: PageTemplateType.ProductPage,
    pageName: 'product',
    killSwitchName: 'spaEnabledProduct',
    url: '/product/'
}, {
    template: PageTemplateType.RwdNthCategory,
    pageName: 'nthCategory',
    killSwitchName: 'spaEnabledCategory',
    url: '/shop/'
}, {
    template: PageTemplateType.RwdBrandNthCategory,
    pageName: 'nthBrand',
    killSwitchName: 'spaEnabledBrand',
    url: '/brand/'
}];

module.exports = { SpaTemplatesInfo };
